<ng-container *ngFor="let option of options; let i = index">
  <div
    class="iris-radio-option"
    [ngClass]="{
      'disabled': control.disabled,
      'templated-label': !!labelTemplate,
      'selected': isSelected(option.value)
    }"
  >
    <div
      *ngIf="showHighlightCircle(option.value)"
      class="iris-radio-highlight-circle absolute-circle"
      [ngClass]="{'lower-circle': option?.details}"
    >
    </div>
    <div class="iris-radio-option-button">  
      <div
        class="iris-radio-option-check"
        *ngIf="isSelected(option.value)"
      >
      </div>
    </div>
    <!-- Note: both `name` and `attr.name` are necessary for the correct tabbing functionality -->
    <input
      class="absolute-circle"
      type="radio"
      [attr.aria-describedby]="formControlName
        && (control.touched | isControlInvalidAndTouched:control.invalid)
          ? formControlName + '-error-messages' : null"
      [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
      [checked]="isSelected(option.value)"
      [value]="option.value"
      [formControl]="control"
      [id]="formControlName ? formControlName + '-radio-option' + i : uniqueId + '-radio-option' + i"
      [name]="formControlName ? formControlName + '-radio-option' + i : uniqueId + '-radio-option' + i"
      [attr.name]="formControlName ? formControlName : uniqueId + '-radio-option' + i"
      [attr.required]="(control | isControlRequired) || null"
      (blur)="onBlur()"
      (focus)="onFocus(option.value)"
      (mouseenter)="onHoverEnter(option.value)"
      (mouseleave)="onHoverLeave()"
    />
    <div class="radio-label">
      <label [for]="formControlName ? formControlName + '-radio-option' + i : uniqueId + '-radio-option' + i">
        <span [attr.data-test]="option.name">
          <iris-icon
            *ngIf="option.iconName && option.iconColor"
            [name]="option.iconName"
            [colorToken]="option.iconColor"
            [size]="iconSize"
          />
          <iris-icon
            *ngIf="option.iconName && !option.iconColor"
            [name]="option.iconName"
            [size]="iconSize"
            [color]="iconColors.BRAND1"
          />
          @if (labelTemplate) {
            <ng-container *ngTemplateOutlet="labelTemplate; context: { $implicit: option }" />
          } @else {
            {{ option.name }}
          }
        </span>
        <span class="details" *ngIf="option?.details">
          {{option.details}}
        </span>
      </label>
    </div>
  </div>
  <ng-container *ngIf="optionTemplate && isSelected(option.value)">
    <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
  </ng-container>
</ng-container>
